module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a6-3-675609ce79d45345a00093a165ce9141.jpg";